import Vue from 'vue'
import moment from 'moment-timezone'
import tzlookup from 'tz-lookup'
import i18n from '@/i18n'

Vue.filter('roundValue', (value, precision) => {
  precision = Math.pow(10, precision)
  value = Math.ceil(value * precision) / precision
  var parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  value = parts.join('.')
  return value
})
Vue.filter('roundValueWeight', (value, precision) => {
  precision = Math.pow(10, precision)
  value = value / 1000
  value = Math.ceil(value * precision) / precision
  var parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  value = parts.join('.')
  return value
})
Vue.filter('roundValueToNumber', (value, precision) => {
  precision = Math.pow(10, precision)
  value = Math.ceil(value * precision) / precision
  return value
})
Vue.filter('roundValueWeightToNumber', (value, precision) => {
  precision = Math.pow(10, precision)
  value = value / 1000
  value = Math.ceil(value * precision) / precision
  return value
})

Vue.filter('dimensionValue', (dim, precision = 0, attributes = false) => {
  if (dim != null) {
    if (attributes) {
      return (
        `${Vue.options.filters.roundValue(dim.length, precision)}` + ' x ' + `${Vue.options.filters.roundValue(dim.width, precision)}` + ' x ' + `${Vue.options.filters.roundValue(dim.height, precision)} (L x W x H) cm`
      )
    }
    return (
      Vue.options.filters.roundValue(dim.length, precision) +
      ' x ' +
      Vue.options.filters.roundValue(dim.width, precision) +
      ' x ' +
      Vue.options.filters.roundValue(dim.height, precision)
    )
  }
  return 0 + ' x ' + 0 + ' x ' + 0
})

// Vue.filter('dateToReadable', (date, lang) => {
//   if (date[date.length - 1] === 'Z') {
//     date = date.slice(0, date.length - 1)
//     date = date + '+02:00'
//   }
//   let d = new Date(date)
//   let options = { weekday: 'short', month: 'short', day: 'numeric' }
//   return d.toLocaleDateString(lang, options)
// })

// 1564569811000 -> 31. 7. 19 (localizated fe. 7/31/19 for EN)
Vue.filter('unixDateToNumeric', (date, lang) => {
  let d = new Date(Number(date))
  let options = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric'
  }
  return d.toLocaleDateString(lang, options)
})

Vue.filter('unixDateToReadableShort', (date, lang) => {
  let d = new Date(date * 1000)
  let options = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  }
  return d.toLocaleDateString(lang, options)
})

Vue.filter('unixDateToReadable', (date, lang) => {
  let d = new Date(date * 1000)
  let options = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  }
  return d.toLocaleDateString(lang, options)
})

Vue.filter('unixDateToReadableNumeric', (date, lang) => {
  if (lang === 'en') { // if selected app language is English, use British, so format will be “DayOfWeek, Day.Month” and not “DayOfWeek, Month.Day”
    lang = 'en-GB'
  }
  let d = new Date(date * 1000)
  let options = {
    weekday: 'short',
    month: 'numeric',
    day: 'numeric'
  }
  return d.toLocaleDateString(lang, options).replace('/', '.')
})

Vue.filter('unixTimeToReadable', (date, lang) => {
  let d = new Date(date * 1000)
  let options = {
    hour: 'numeric',
    minute: 'numeric'
  }
  return d.toLocaleTimeString(lang, options)
})
Vue.filter('dateToReadable', (date, lang) => {
  // const timezone = moment.tz.guess()
  // moment.tz.setDefault(timezone)
  if (date != null) {
    moment.locale(lang)
    if (moment.unix(date).isValid()) {
      const returnedDate = moment.unix(date).format('ddd, DD.M[.]')
      return returnedDate
    } else if (moment(date).isValid()) {
      const returnedDate = moment(date).format('ddd, DD.M[.]')
      return returnedDate
    } else {
      return null
    }
  }
  return date
})
Vue.filter('timeToReadable', (date, lang) => {
  // const timezone = moment.tz.guess()
  // moment.tz.setDefault(timezone)
  moment.locale(lang)
  if (typeof (date) !== 'number') {
    const returnedTime = moment(date).format('HH:mm')
    return moment(returnedTime, 'HH:mm', true).isValid() ? returnedTime : null
  } else {
    const returnedTime = moment.unix(date).format('HH:mm')
    return moment(returnedTime, 'HH:mm', true).isValid() ? returnedTime : null
  }
})
Vue.filter('unixTimeToReadable24h', (date, lang) => {
  // moment.tz.setDefault('UTC')
  moment.locale(lang)
  let unixTime = moment.unix(date).format('HH:mm')
  let time = moment(date).format('HH:mm')
  if (unixTime !== 'Invalid date') {
    return unixTime
  } else if (time !== 'Invalid date') {
    return time
  } else {
    return unixTime
  }
})

Vue.filter('justTime', (date, lang) => {
  if (date[date.length - 1] === 'Z') {
    date = date.slice(0, date.length - 1)
    date = date + '+02:00'
  }
  let d = new Date(date)
  let options = {
    hour: 'numeric',
    minute: 'numeric'
  }
  return d.toLocaleTimeString(lang, options)
})

Vue.filter('dateToReadableFull', (date, lang) => {
  if (date[date.length - 1] === 'Z') {
    date = date.slice(0, date.length - 1)
    date = date + '+02:00'
  }
  let d = new Date(date)
  let options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }
  return d.toLocaleDateString(lang, options)
})

Vue.filter('datetimeToISO', date => {
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() + 1 < 10 ? '0' : '') +
    (date.getMonth() + 1) +
    '-' +
    (date.getDate() < 10 ? '0' : '') +
    date.getDate()
  )
})

Vue.filter('unixTStoDateTime', (date, lang) => {
  let d = new Date(date)
  let options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }
  return d.toLocaleDateString(lang, options)
})

Vue.filter('licensePlateValue', str => {
  return str.substring(0, 3) + ' ' + str.substring(3, str.length)
})

Vue.filter('AddressObjectToString', (object, attributes) => {
  let addressString = ''
  if (object != null) {
    if (typeof object === 'string') {
      return object
    }
    attributes.forEach((key, index) => {
      if (Array.isArray(key)) {
        key.forEach((secondKey, secondIndex) => {
          if (object[secondKey] !== undefined && object[secondKey] !== null) {
            if (index === 0 && secondIndex === 0) {
              addressString += object[secondKey]
            } else {
              addressString += ` ${object[secondKey]}`
            }
          }
        })
      } else {
        if (object[key] !== undefined && object[key] !== null) {
          if (index === 0) {
            addressString += object[key]
          } else {
            if (addressString.length < 1) {
              addressString += `${object[key]}`
            } else {
              addressString += `, ${object[key]}`
            }
          }
        }
      }
    })
  }
  return addressString
})
Vue.filter('rfc3339To24h', (date, lang) => {
  moment.locale(lang)
  return moment(date).format('HH:mm')
})
Vue.filter('rfc3339ToDate', (date, lang) => {
  moment.locale(lang)
  return moment(date).format('ddd, MMM DD')
})
Vue.filter('quotePrice', (value) => {
  if (value[0] != null) {
    const humanizePrice = value[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    return `${humanizePrice} ${value[1]}`
  } else {
    return `${value} CZK`
  }
})

// Filter date and time based on Coordinates timezone
Vue.filter('dateToReadableTzCoordinates', (date, coordinates, lang) => {
  moment.locale(lang)
  let timezone = 'Europe/Prague'
  if (coordinates != null) {
    timezone = tzlookup(coordinates.lat, coordinates.lng)
  }
  if (moment.unix(date).isValid()) {
    const returnedDate = moment.unix(date).tz(timezone).format('ddd, DD.M zz')
    return returnedDate
  } else {
    const returnedDate = moment(date).tz(timezone).format('ddd, DD.M zz')
    return returnedDate
  }
})
Vue.filter('timeToReadableTzCoordinates', (date, coordinates, lang) => {
  moment.locale(lang)
  let timezone = 'Europe/Prague'
  if (coordinates != null) {
    timezone = tzlookup(coordinates.lat, coordinates.lng)
  }
  if (moment.unix(date).isValid()) {
    const returnedTime = moment.unix(date).tz(timezone).format('HH:mm')
    return returnedTime
  } else {
    const returnedTime = moment(date).tz(timezone).format('HH:mm')
    return returnedTime
  }
})
Vue.filter('dateToReadableSchedule', (date) => {
  moment.locale(i18n.locale)
  if (moment.unix(date).isValid()) {
    const returnedDate = moment.unix(date).format('ddd, DD.M. z')
    return returnedDate
  } else {
    const returnedDate = moment(date).format('ddd, DD.M. z')
    return returnedDate
  }
})
Vue.filter('timeToReadableSchedule', (date) => {
  moment.locale(i18n.locale)
  moment.tz.setDefault(moment.tz.guess())
  if (moment.unix(date).isValid()) {
    const returnedTime = moment.unix(date).utc(true).format('HH:mm')
    return returnedTime
  } else {
    const returnedTime = moment.parseZone(date).format('HH:mm')
    return returnedTime
  }
})



Vue.filter('dateToReadableUTC', (date, lang) => {
  moment.locale(lang)
  // const timezone = moment.tz.guess()
  // moment.tz.setDefault('UTC')
  if (moment.unix(date).isValid()) {
    const returnedDate = moment.unix(date).format('ddd, DD.M')
    return returnedDate
  } else {
    const returnedDate = moment(date).format('ddd, DD.M')
    return returnedDate
  }
})
Vue.filter('dateToReadableTz', (date, lang) => {
  moment.locale(lang)
  const timezone = 'Europe/Prague'
  if (moment.unix(date).isValid()) {
    const returnedDate = moment.unix(date).tz(timezone).format('ddd, DD.M.')
    return returnedDate
  } else {
    const returnedDate = moment(date).tz(timezone).format('ddd, DD.M.')
    return returnedDate
  }
})
Vue.filter('timeToReadableTz', (date, lang) => {
  if (date != null) {
    moment.locale(lang)
    const timezone = 'Europe/Prague'
    if (moment.unix(date).isValid()) {
      const returnedDate = moment.unix(date).tz(timezone).format('HH:mm')
      return returnedDate
    } else if (moment(date).isValid()) {
      const returnedDate = moment(date).tz(timezone).format('HH:mm')
      return returnedDate
    } else {
      return null
     }
  }
  return null
})
Vue.filter('dateToReadableFullMoment', (date, lang) => {
  // moment.tz.setDefault('Europe/Prague')
  // console.log(date)
  moment.locale(lang)
  if (moment.unix(date).isValid()) {
    const returnedDate = moment.unix(date).tz('Europe/Prague').format('ddd, DD MMM, Y')
    return returnedDate
  } else {
    const returnedDate = moment(date).tz('Europe/Prague').format('ddd, DD MMM, Y')
    return returnedDate
  }
})
Vue.filter('timeToReadableFullMoment', (date, lang) => {
  // moment.tz.setDefault('Europe/Prague')
  moment.locale(lang)
  if (moment.unix(date).isValid()) {
    const returnedDate = moment.unix(date).tz('Europe/Prague').format('HH:mm')
    return returnedDate
  } else {
    const returnedDate = moment(date).tz('Europe/Prague').format('HH:mm')
    return returnedDate
  }
})
Vue.filter('dateTimeToReadableFullMoment', (date, lang) => {
  // moment.tz.setDefault('Europe/Prague')
  if (date != null) {
    moment.locale(lang)
    if (moment.unix(date).isValid()) {
      const returnedDate = moment.unix(date).format('ddd, DD.M. Y HH:mm')
      return returnedDate
    } else if (moment(date).isValid()) {
      const returnedDate = moment(date).format('ddd, DD.M. Y HH:mm')
      return returnedDate
    } else {
      return null
    }
  }
})
Vue.filter('userFullName', (name) => {
  let nameArray = []
  if (name != null) {
    if (name['__typename'] != null) {
      delete name['__typename']
    }
    Object.values(name).forEach((values) => {
      if (values != null) {
        nameArray.push(values)
      }
    })
    return nameArray.join(' ')
  }
  return name
})
Vue.filter('scheduleDuration', (duration) => {
  const diff = moment.duration(duration, 'seconds')
  switch (true) {
    case (diff.asSeconds() < 60):
      return Math.ceil(diff.asSeconds()) + ' s'
    case (diff.asMinutes() < 60):
      return Math.ceil(diff.asMinutes()) + ' m'
    case (diff.asHours() < 24):
      return Math.ceil(diff.asHours()) + ' h'
    default:
      return Math.ceil(diff.asDays()) + ' d'
  }
})

Vue.filter('openingHoursText', (timeObject) => {
  let timeText = ''
  if (timeObject != null) {
    const timeArray = Object.values(timeObject)
    timeArray.forEach((time, index) => {
      if (`${time}`.length < 2) {
        timeText += `0${time}${index ? '' : ':'}`
      } else {
        timeText += `${time}${index ? '' : ':'}`
      }
    })
  }
  return timeText
})
Vue.filter('openingHoursContext', (timeObject) => {
  let timeText = ''
  if (timeObject != null) {
    const timeArray = Object.values(timeObject)
    const removedIndex = Object.keys(timeObject).findIndex((key) => key === '__typename')
    timeArray.forEach((time, index) => {
      if (index !== removedIndex) {
        if (`${time}`.length < 2) {
          timeText += `${index === 2 ? '-': ''}0${time}${index%2 ? '' : ':'}`
        } else {
          timeText += `${index === 2 ? '-': ''}${time}${index%2 ? '' : ':'}`
        }
      }
    })
  }
  return timeText
})
Vue.filter('filterIsNaN', (number) => {
  return isNaN(number) ? 0 : number
})
Vue.filter('priceWithCurrency', (priceObject) => {
  if (priceObject != null) {
    if (priceObject.price != null && priceObject.currency != null) {
      const humanizePrice = priceObject.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      return `${humanizePrice} ${priceObject.currency}`
    }
    return priceObject
  }
  return ''
})
Vue.filter('userPrimaryEmail', (contacts) => {
  if (contacts != null) {
    if (Array.isArray(contacts)) {
      const index = contacts.findIndex(({ type }) => type === 'Email')
      if (index >= 0) {
        return contacts[index].value
      }
    }
  }
  return null
})
Vue.filter('humanizeNumber', function (value) {
  if (value != null) {
    return Math.ceil(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
  return value
})
Vue.filter('filterDistance', function (value) {
  if (value != null) {
    return `${Math.round(value / 1000)} km`
  }
  return null
})
Vue.filter('filterDuration', function (value) {
  if (value != null) {
    const diffSeconds = value
    const diffMinutes = moment.duration({seconds: value}).asMinutes()
    const diffHours = moment.duration({seconds: value}).asHours()
    const diffDays = moment.duration({seconds: value}).asDays()
    switch (true) {
      case (diffSeconds < 60):
        return Math.ceil(diffSeconds) + ' s'
      case (diffMinutes < 60):
        return Math.ceil(diffMinutes) + ' m'
      case (diffHours < 24):
        return Math.ceil(diffHours) + ' h'
      default:
        return Math.ceil(diffDays) + ' d'
    }
  }
  return null
})
Vue.filter('durationToHoursMinutes', function (value) {
  if (value != null) {
    // const momentDuration = moment.duration({seconds: value })
    // Issue AW-643 Issue with moment durations when hours was more than 24
    if (value > 3599) {
      var hours = ((value / 60) / 60)
      var rHours = Math.floor(hours)
      var minutes = (hours - rHours) * 60
      var rMinutes = Math.round(minutes)
      return `${rHours}hr ${rMinutes}mins`
    } else {
      return `${Math.round((value / 60))}mins`
      // return moment.utc(momentDuration.asMilliseconds()).format('m[mins]')
    }
  }
  return null
})

Vue.filter('utilizationVolumeDimensions', (volume, length, width, height, precision = 0) => {
  let precisionPow = Math.pow(10, precision)
  let maxVolume = ((length * width * height) / 1000000)
  let value = ( ( volume / maxVolume ) * 100 )
  value = Math.ceil(value * precisionPow) / precisionPow
  var parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  value = parts.join('.')
  return value
})
Vue.filter('utilizationVolume', (volume, maxVolume, precision = 0) => {
  let precisionPow = Math.pow(10, precision)
  let value = 0
  if (maxVolume != null) {
    value = ( ( volume / maxVolume ) * 100 )
  } else {
    value = volume
  }
  value = Math.ceil(value * precisionPow) / precisionPow
  var parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  value = parts.join('.')
  return value
})
Vue.filter('utilizationWeight', (weight, maxWeight, precision = 0) => {
  let precisionPow = Math.pow(10, precision)
  let value = 0
  if (maxWeight != null) {
    value = ( ( weight / maxWeight ) * 100 )
  } else {
    value = weight
  }
  value = Math.ceil(value * precisionPow) / precisionPow
  var parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  value = parts.join('.')
  return value
})

Vue.filter('euroPalletDimensions', ({ width, length, height }) => {
  return `(${length} x ${width} cm) (L x W)`
})
Vue.filter('customPalletDimensions', ({ width, length, height }) => {
  return `(${length} x ${width} x ${height} cm)`
})
